<template>
  <div>
    <a-row type="flex" justify="space-between">
      <a-col :span="11">
        <Categories />
      </a-col>
      <a-col :span="12">
        <Countries />
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <Apikey></Apikey>
    <a-divider></a-divider>

    <a-row type="flex" justify="space-between">
      <a-col :span="24">
        <a-form layout="vertical" :form="formVar" @submit="submitVar">
          <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">
            Secrets
          </h1>
          <a-form-item style="display: none;">
            <a-input v-decorator="['id']" class="shadowInputs" />
          </a-form-item>
          <a-row type="flex" justify="space-between" :gutter="20">
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                AWS KEY
              </span>
                <a-input v-decorator="['aws_key']" class="shadowInputs" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                AWS SECRET
              </span>
                <a-input v-decorator="['aws_secret']" class="shadowInputs" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                AWS REGION
              </span>
                <a-input v-decorator="['aws_region']" class="shadowInputs" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                Timezone
              </span>
                <a-input v-decorator="['timezone']" class="shadowInputs" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                MAILCHIMP API KEY
              </span>
                <a-input v-decorator="['mailchimp_api_key']" class="shadowInputs" />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item>
              <span slot="label">
                MAILCHIMP SERVER
              </span>
                <a-input v-decorator="['mailchimp_server']" class="shadowInputs" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-form-item>
            <a-row type="flex" justify="end" align="middle" :gutter="20">
              <a-col><a-button type="primary" html-type="submit" size="large">Guardar</a-button></a-col>
              <!-- <a-col><a-button size="large">Cancelar</a-button></a-col> -->
            </a-row>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>

</template>

<script>
import utils from '../service/service.js'
import Apikey from "@/components/Apikey.vue";
import Categories from "@/components/Categories.vue"
import Countries from "@/components/Countries.vue"
export default {
  name: "Configurations",
  components: {Categories, Apikey, Countries},
  // props: {},
  mixins: [utils],
  data() {
    return {
      formVar: this.$form.createForm(this)
    }
  },
  mounted: function () {
    this.getList();
    this.sendRequest({
      method:'POST',
      url:'setup/templates'
    });
  },
  methods: {
    async submitVar(e) {
      e.preventDefault();
      const data = this.formVar.getFieldsValue();
      const { code, message } = await this.sendRequest({
        method: 'POST',
        url: 'configurations/edit',
        data: data,
      })
      if (code === 200) {
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },
    async getList(e) {
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'configurations/list',
      })
      this.formVar.setFieldsValue(data);
    },
  },
  computed: {
  },
};
</script>

<style scoped>

</style>
